import { getCookie, setCookie, deleteCookie } from 'granite-admin/utils/storage';
const params = new URLSearchParams(window.location.search);
const embed = params.get('embed');
let auth = {};
let organisation = {};
let myOrganisations = [];
var storage = window['localStorage'];
let fetching = [];
let extraAPIParams = {};
function loadAuthToken() {
  let authToken;
  if (storage) {
    authToken = embed ? localStorage.getItem('iframeAuthToken') : localStorage.getItem('authToken');
  } else {
    authToken = embed ? getCookie('iframeAuthToken') : getCookie('authToken');
  }
  if (embed) auth.iframe_token = authToken;else auth.token = authToken;
}
function setAuthToken(authToken) {
  if (storage) {
    embed ? localStorage.setItem('iframeAuthToken', authToken) : localStorage.setItem('authToken', authToken);
  } else {
    embed ? setCookie('iframeAuthToken', authToken) : setCookie('authToken', authToken);
  }
  if (embed) auth.iframe_token = authToken;else auth.token = authToken;
}
function getAuthToken() {
  return embed ? auth.iframe_token : auth.token;
}
function resetAuthToken() {
  if (storage) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('iframeAuthToken');
    localStorage.removeItem('organisation');
    localStorage.removeItem('iframeOrganisation');
    localStorage.removeItem('myOrganisations');
  } else {
    deleteCookie('authToken');
    deleteCookie('iframeAuthToken');
    deleteCookie('organisation');
    deleteCookie('iframeOrganisation');
    deleteCookie('myOrganisations');
  }
  organisation = {};
  myOrganisations = [];
  auth.token = null;
  auth.iframe_token = null;
  resetFetching();
}
function loadOrganisation() {
  let pk;
  if (storage) {
    pk = embed ? localStorage.getItem('iframeOrganisation') : localStorage.getItem('organisation');
  } else {
    pk = embed ? getCookie('iframeOrganisation') : getCookie('organisation');
  }
  if (embed) organisation.iframePk = +pk;else organisation.pk = +pk;
}
function setOrganisation(pk) {
  if (storage) {
    embed ? localStorage.setItem('iframeOrganisation', pk) : localStorage.setItem('organisation', pk);
  } else {
    embed ? setCookie('iframeOrganisation', pk) : setCookie('organisation', pk);
  }
  if (embed) organisation.iframePk = pk;else organisation.pk = pk;
}
function getOrganisation() {
  return embed ? organisation.iframePk : organisation.pk;
}
function resetOrganisation() {
  if (storage) {
    localStorage.removeItem('organisation');
    localStorage.removeItem('iframeOrganisation');
  } else {
    deleteCookie('organisation');
    deleteCookie('iframeOrganisation');
  }
  organisation = {};
  resetFetching();
}
function loadMyOrganisations() {
  const orgs = localStorage.getItem('myOrganisations');
  myOrganisations = JSON.parse(orgs);
}
function setMyOrganisations(orgs) {
  localStorage.setItem('myOrganisations', JSON.stringify(orgs));
  myOrganisations = orgs;
  resetFetching();
}
function getMyOrganisations() {
  return myOrganisations;
}
function resetMyOrganisations() {
  localStorage.removeItem('myOrganisations');
  myOrganisations = [];
  resetFetching();
}
function getFetching() {
  return fetching;
}
function setFetching(data, {
  remove = false,
  reset = false
} = {}) {
  if (remove) fetching = fetching.filter(i => i.uuid !== data);else if (reset) fetching = data;else fetching.push(data);
}
function resetFetching() {
  fetching = [];
}
function setSsoLogin() {
  if (storage) localStorage.setItem('ssoLogin', 'true');else setCookie('ssoLogin', 'true');
}
function checkSsoLogin() {
  if (storage) return localStorage.getItem('ssoLogin');else return getCookie('ssoLogin');
}
function resetSsoLogin() {
  if (storage) localStorage.removeItem('ssoLogin');else deleteCookie('ssoLogin');
}
function setExtraAPIParams(data) {
  extraAPIParams = {
    ...extraAPIParams,
    ...data
  };
}
function getExtraAPIParams() {
  return extraAPIParams;
}
export { loadAuthToken, setAuthToken, getAuthToken, resetAuthToken, loadOrganisation, setOrganisation, getOrganisation, resetOrganisation, loadMyOrganisations, setMyOrganisations, getMyOrganisations, resetMyOrganisations, getFetching, setFetching, resetFetching, setSsoLogin, checkSsoLogin, resetSsoLogin, setExtraAPIParams, getExtraAPIParams };